module.exports = __webpack_public_path__ + "exo-latin-800.ca084c98b9f30fcf576f.eot";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-800.eot
// module id = ../../../../typeface-exo/files/exo-latin-800.eot
// module chunks = styles